import r from 'react';
import { useRefCallback } from '@crossbell/util-hooks';
import { BaseModal, Indicator, CloseIcon, Loading, LoadMore, useUrlComposer, CharacterAvatar, CrossbellChainLogo } from '@crossbell/ui';
import { create } from 'zustand';
import { useAccountCharacter } from '@crossbell/react-account';
import { useCharacterNotification, useMarkCharacterNotificationAsRead, useCharacterNotificationUnreadCount } from '@crossbell/indexer';
import Y from 'classnames';
import D from 'dayjs';
import { formatUnits } from 'viem';
import ee from 'dayjs/plugin/relativeTime.js';
import { extractCharacterName } from '@crossbell/util-metadata';

var v=create(e=>({isModalActive:!1,showModal(){e({isModalActive:!0});},hideModal(){e({isModalActive:!1});}}));var Q=["OPERATOR_ADDED","OPERATOR_REMOVED","LINKED","UNLINKED","NOTE_MINTED","NOTE_POSTED","MENTIONED","TIPPED"];function C(e){let t=useAccountCharacter()?.characterId,{data:i,...o}=useCharacterNotification(t,e?.types??Q),{mutate:h}=useMarkCharacterNotificationAsRead(t),{data:d}=useCharacterNotificationUnreadCount(t),x=r.useMemo(()=>i?.pages.flatMap(({list:p})=>e?.filter?p.filter(e?.filter):p)??[],[i,e?.filter]),m=i?.pages?.[0]?.count??0,f=d===0,g=useRefCallback(()=>{f||h();});return {notifications:x,total:m,isAllRead:f,unreadCount:d,markAllRead:g,...o}}var T="1cb5310c9d62e9d6b338708e09919c9edf632a6de9a24477f93ebb333692d153",W=`._modal_mnxr0_1 {
	--csb-notification-color-text: #000;
	--csb-notification-color-textSecondary: #687792;
	--csb-notification-color-closeBtn: #999;
	--csb-notification-color-border: #999;
	--csb-notification-color-background: #fff;
	--csb-notification-color-indicator-text: #fff;
	--csb-notification-color-indicator: #fa5252;
	--csb-notification-color-transactionHash: #f6c549;
	--csb-notification-color-bellPrimary: #f6c549;
	--csb-notification-color-bellSecondary: #d2a52a;

	width: 600px;
	max-width: 90vw;
	overflow: hidden;
	padding: 24px 0;
	color: var(--csb-notification-color-text);
	background: var(--csb-notification-color-background);
	border: 1px solid var(--csb-notification-color-border);
	border-radius: 28px;
}

._header_mnxr0_23 {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 0 24px;
	margin-bottom: 10px;
}

._headerBell_mnxr0_31 {
	font-size: 24px;
}

._headerTitle_mnxr0_35 {
	font-size: 22px;
	font-weight: 500;
	margin-right: auto;
}

._loader_mnxr0_41,
._noNotificationTips_mnxr0_42 {
	height: 30vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

._loader_mnxr0_41 {
	font-size: 36px;
	color: var(--csb-notification-color-text);
	opacity: 0.5;
}

._scrollArea_mnxr0_55 {
	padding: 0 24px;
	min-height: 30vh;
	max-height: 70vh;
	overflow: auto;
}

._closeBtn_mnxr0_62 {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	border: none;
	background: transparent;
	outline: none;
	border-radius: 8px;
	color: var(--csb-notification-color-closeBtn);
	transition: background-color 0.2s;
}

._closeBtn_mnxr0_62:hover {
	background: rgba(50%, 50%, 50%, 0.1);
}

._closeBtn_mnxr0_62:active {
	background: rgba(50%, 50%, 50%, 0.3);
}

@media (min-width: 768px) {
	._headerBell_mnxr0_31 {
		font-size: 32px;
	}

	._headerTitle_mnxr0_35 {
		font-size: 28px;
	}
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(T)){var e=document.createElement("style");e.id=T,e.textContent=W,document.head.appendChild(e);}})();var a={modal:"_modal_mnxr0_1",header:"_header_mnxr0_23",headerBell:"_headerBell_mnxr0_31",headerTitle:"_headerTitle_mnxr0_35",loader:"_loader_mnxr0_41",noNotificationTips:"_noNotificationTips_mnxr0_42",scrollArea:"_scrollArea_mnxr0_55",closeBtn:"_closeBtn_mnxr0_62"};var E="2eda0fa109e00aa5697110ad63061e68a23b202f9916f0098e40813a0349f5ca",X=`._container_f0i4s_1 {
	position: relative;
	line-height: 0;
}

._primary_f0i4s_6 {
	fill: var(--csb-notification-color-bellPrimary);
}

._secondary_f0i4s_10 {
	fill: var(--csb-notification-color-bellSecondary);
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(E)){var e=document.createElement("style");e.id=E,e.textContent=X,document.head.appendChild(e);}})();var _={container:"_container_f0i4s_1",primary:"_primary_f0i4s_6",secondary:"_secondary_f0i4s_10"};function M({className:e,...t}){return r.createElement("div",{className:Y(_.container,e),...t},r.createElement("svg",{width:"1em",height:"1em",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},r.createElement("g",{clipPath:"url(#clip0_5339_20129)"},r.createElement("path",{className:_.primary,fillRule:"evenodd",clipRule:"evenodd",d:"M12 0.428589C10.0124 0.428589 8.10623 1.21815 6.70081 2.62356C5.29539 4.02898 4.50582 5.93515 4.50582 7.92273C4.50582 9.33742 4.2562 10.4147 3.9094 11.2303C3.81225 11.4588 3.61583 11.6561 3.23843 11.8976C3.09102 11.9919 2.94013 12.0786 2.76868 12.1771L2.76865 12.1771L2.60831 12.2695C2.38016 12.4016 2.12341 12.555 1.87816 12.7365L2.38816 13.4254L1.87816 12.7365C0.991407 13.393 0.665478 14.4046 0.70952 15.3166C0.752377 16.2041 1.15021 17.1292 1.89268 17.6875C1.90281 17.6956 1.91421 17.7043 1.92692 17.7137C1.95716 17.7364 1.99487 17.7628 2.04111 17.7924C2.13354 17.8519 2.25999 17.9244 2.42869 18.0052C2.76563 18.1665 3.27354 18.3617 4.02061 18.5506C5.51178 18.9274 7.98181 19.2857 12 19.2857C16.0181 19.2857 18.4881 18.9274 19.9793 18.5506C20.7264 18.3617 21.2343 18.1665 21.5712 18.0052C21.7399 17.9244 21.8664 17.8519 21.9588 17.7924C22.0051 17.7628 22.0428 17.7364 22.073 17.7137C22.0857 17.7043 22.0971 17.6956 22.1073 17.6875C22.8497 17.1292 23.2476 16.2041 23.2904 15.3166C23.3345 14.4046 23.0084 13.393 22.1218 12.7365C21.8765 12.555 21.6197 12.4016 21.3915 12.2695L21.2313 12.1771C21.0598 12.0786 20.909 11.9919 20.7615 11.8976C20.3841 11.6561 20.1876 11.4587 20.0904 11.2303C20.0184 11.0609 19.9508 10.8806 19.8888 10.6888C19.646 9.74419 19.494 8.8541 19.494 7.92273C19.494 5.93515 18.7046 4.02898 17.299 2.62356C15.8937 1.21815 13.9875 0.428589 12 0.428589Z",fill:"#F6C549"}),r.createElement("path",{className:_.secondary,fillRule:"evenodd",clipRule:"evenodd",d:"M9.07859 20.8022C9.30628 20.5335 9.67507 20.4315 10.0084 20.5449C10.4426 20.6926 11.084 20.8054 12 20.8054C12.9159 20.8054 13.5574 20.6926 13.9915 20.5449C14.3249 20.4315 14.6937 20.5335 14.9214 20.8022C15.1491 21.0708 15.1893 21.4512 15.0229 21.7615C14.4462 22.8369 13.3095 23.5714 12 23.5714C10.6905 23.5714 9.5538 22.8369 8.97703 21.7615C8.81061 21.4512 8.85089 21.0708 9.07859 20.8022Z",fill:"#D2A52A"})),r.createElement("defs",null,r.createElement("clipPath",{id:"clip0_5339_20129"},r.createElement("rect",{width:"24",height:"24",fill:"white"})))))}var w="d44d047f878fa400b6fd84084546e07de4aab387535b9a01230b88c7ae135d30",R=`._container_dzu3d_1 {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 0;
}

._main_dzu3d_8 {
	flex: 1;
}

._main_dzu3d_8 a:hover {
	text-decoration: underline;
}

._description_dzu3d_16 {
	font-size: 12px;
	display: flex;
	flex-wrap: wrap;
}

._description_dzu3d_16 > *:not(:last-child) {
	margin-right: 0.5ch;
}

._characterName_dzu3d_26 {
	font-weight: 500;
	max-width: 180px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

._transactionHash_dzu3d_34 {
	color: var(--csb-notification-color-transactionHash);
}

._transactionHash_dzu3d_34 svg {
	display: inline-block;
	margin: 0 2px 0 4px;
}

._actionDesc_dzu3d_43 a:hover {
	text-decoration: underline;
}

._title_dzu3d_47 {
	display: flex;
	font-weight: 400;
	font-size: 12px;
	color: var(--csb-notification-color-textSecondary);
}

._title_dzu3d_47 a {
	flex: 1;
	width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(w)){var e=document.createElement("style");e.id=w,e.textContent=R,document.head.appendChild(e);}})();var c={container:"_container_dzu3d_1",main:"_main_dzu3d_8",description:"_description_dzu3d_16",characterName:"_characterName_dzu3d_26",transactionHash:"_transactionHash_dzu3d_34",actionDesc:"_actionDesc_dzu3d_43",title:"_title_dzu3d_47"};D.extend(ee);function k({notification:e,isRead:t}){let i=useUrlComposer(),o=se(e,i);return r.createElement("div",{className:c.container},r.createElement("a",{href:A(e,i),target:"_blank",rel:"noreferrer"},r.createElement(Indicator,{disabled:t},r.createElement(CharacterAvatar,{character:e.fromCharacter,size:38}))),r.createElement("div",{className:c.main},r.createElement("div",{className:c.description},r.createElement("a",{className:c.characterName,href:A(e,i),target:"_blank",rel:"noreferrer"},ce(e)),r.createElement("span",{className:c.actionDesc},ae(e,i)),r.createElement("span",null,le(e)),r.createElement("span",null,"on",ne(e.transactionHash,i))),o&&r.createElement("div",{className:c.title},r.createElement("a",{href:o.url,target:"_blank",rel:"noreferrer"},o.title))))}function ne(e,t){return r.createElement("a",{href:t.scanTxUrl({txHash:e}),target:"_blank",rel:"noreferrer",className:c.transactionHash},r.createElement(CrossbellChainLogo,null),"Crossbell Chain")}function ae(e,t){switch(e.type){case"comment-note":return r.createElement("span",null,"commented your ",r.createElement("a",{href:t.noteUrl(e.originNote),title:e.originNote.metadata?.content?.content},"Note"));case"like-note":return r.createElement("span",null,"liked your Note");case"mint-note":return r.createElement("span",null,"minted your Note");case"follow-character":return r.createElement("span",null,"followed you");case"tip-note":return r.createElement("span",null,`tipped you ${formatUnits(e.amount,18)} `,r.createElement("a",{href:"https://mira.crossbell.io/",target:"_blank"},"MIRA")," on your Note");case"tip-character":return r.createElement("span",null,`tipped you ${formatUnits(e.amount,18)} `,r.createElement("a",{href:"https://mira.crossbell.io/",target:"_blank"},"MIRA"));case"mention":return r.createElement("span",null,"mentioned you")}return null}function se(e,t){switch(e.type){case"comment-note":return {title:u(e.commentNote),url:t.noteUrl(e.commentNote)};case"like-note":case"mint-note":return {title:u(e.originNote),url:t.noteUrl(e.originNote)};case"tip-note":return {title:u(e.toNote),url:t.noteUrl(e.toNote)};case"mention":return {title:u(e.fromNote),url:t.noteUrl(e.fromNote)}}return null}function u(e){return e?.metadata?.content?.title||e?.metadata?.content?.content||"Note"}function ce(e){switch(e.type){case"mint-note":return e.fromCharacter?extractCharacterName(e.fromCharacter):e.fromAddress;default:return extractCharacterName(e.fromCharacter)}}function A(e,t){switch(e.type){case"mint-note":return e.fromCharacter?t.characterUrl(e.fromCharacter):void 0;default:return t.characterUrl(e.fromCharacter)}}function le(e){return D(e.createdAt).fromNow()}function z(e){var t,i,o="";if(typeof e=="string"||typeof e=="number")o+=e;else if(typeof e=="object")if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(i=z(e[t]))&&(o&&(o+=" "),o+=i);else for(t in e)e[t]&&(o&&(o+=" "),o+=t);return o}function de(){for(var e,t,i=0,o="";i<arguments.length;)(e=arguments[i++])&&(t=z(e))&&(o&&(o+=" "),o+=t);return o}var O=de;var B="8f4e9b540e1b4ce627a20dc8857db3a872bce5f8760bd6767bde3f58a85f592a",me=`._container_fmmv3_1 {
	display: flex;
	gap: 24px;
	padding: 0 24px;
	margin-bottom: 4px;
}

._item_fmmv3_8 {
	position: relative;
	display: flex;
	height: 32px;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	font-weight: 700;
	white-space: nowrap;
	cursor: pointer;
	transition: color 0.2s;
}

._item_fmmv3_8::after {
	content: "";
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 2px;
	border-radius: 2px;
	background-color: transparent;
	transition: background-color 0.2s;
}

._item_fmmv3_8._active_fmmv3_33 {
	color: var(--csb-notification-color-text);
}

._item_fmmv3_8._active_fmmv3_33::after {
	background: var(--csb-notification-color-text);
}

._item_fmmv3_8._inactive_fmmv3_41 {
	font-weight: 500;
	color: var(--csb-notification-color-textSecondary);
	border-color: transparent;
}

._item_fmmv3_8._inactive_fmmv3_41:hover {
	color: var(--csb-notification-color-text);
}

@media (min-width: 768px) {
	._item_fmmv3_8 {
		font-size: 14px;
	}
}

._count_fmmv3_57 {
	font-size: 11px;
	line-height: 16px;
	padding: 0 4.5px;
	color: var(--csb-notification-color-indicator-text);
	background-color: var(--csb-notification-color-indicator);
	border-radius: 4px;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(B)){var e=document.createElement("style");e.id=B,e.textContent=me,document.head.appendChild(e);}})();var l={container:"_container_fmmv3_1",item:"_item_fmmv3_8",active:"_active_fmmv3_33",inactive:"_inactive_fmmv3_41",count:"_count_fmmv3_57"};function S({items:e,currentTypeId:t,onSelectTab:i}){return r.createElement("nav",{className:l.container,"aria-label":"Tabs"},e.map(o=>r.createElement("a",{key:o.id,onClick:()=>i(o.id),className:O(o.id===t?l.active:l.inactive,l.item)},o.name,!!o.count&&r.createElement("span",{className:l.count},o.count))))}function at(){return v(e=>e.showModal)}var ge={all:["OPERATOR_ADDED","OPERATOR_REMOVED","LINKED","UNLINKED","NOTE_MINTED","NOTE_POSTED","MENTIONED","TIPPED"],interactions:["OPERATOR_ADDED","OPERATOR_REMOVED","LINKED","UNLINKED","NOTE_POSTED","MENTIONED"],earnings:["NOTE_MINTED","TIPPED"]};function st({colorScheme:e,filter:t}){let[i,o]=r.useState("all"),{notifications:h,total:d,markAllRead:x,isAllRead:m,unreadCount:f,isLoading:g,fetchNextPage:p,hasNextPage:U,isFetchingNextPage:L}=C({types:ge[i],filter:t}),K=Ne(e),{isModalActive:H,hideModal:F}=v(),y=useRefCallback(()=>{F(),x();});return r.createElement(BaseModal,{onClickBg:y,isActive:H},r.createElement("div",{className:a.modal,style:K},r.createElement("div",{className:a.header},r.createElement(Indicator,{disabled:m},r.createElement(M,{className:a.headerBell})),r.createElement("span",{className:a.headerTitle},"Notifications"),r.createElement("button",{className:a.closeBtn,onClick:y},r.createElement(CloseIcon,null))),r.createElement(S,{items:[{name:"View All",id:"all",count:f},{name:"Interactions",id:"interactions"},{name:"Earnings",id:"earnings"}],currentTypeId:i,onSelectTab:o}),r.createElement("div",{className:a.scrollArea},g?r.createElement("div",{className:a.loader},r.createElement(Loading,null)):d>0?r.createElement("div",null,h.map(N=>r.createElement(k,{notification:N,isRead:m||N.isReadBefore,key:N.transactionHash})),r.createElement(LoadMore,{onLoadMore:()=>p(),hasMore:!!U,isLoading:L})):r.createElement("div",{className:a.noNotificationTips},"No notification yet"))))}function Ne(e={}){return r.useMemo(()=>{let t={};return Object.entries(e).forEach(([i,o])=>{t[`--csb-notification-color-${i}`]=o;}),t},[e])}

export { st as NotificationModal, C as useNotifications, at as useShowNotificationModal };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map